import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styles from "./Packageoption.module.css";
import PackageCard from "./PackageCard";
import family from './family image.webp';

import img1 from "./1.webp";
import img2 from "./2.webp";
import img3 from "./3.webp";
import img4 from "./4.webp";

const images = [img1, img2, img3, img4];

export default function CouplePackage() {
  const [current, setCurrent] = useState(0);

  // auto carousel
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <main className={styles.pkgContainer}>
 

      {/* HERO CAROUSEL */}
      <section className={styles.pkgHero}>
        <img src={images[current]} alt="package" />
      </section>

      {/* HEADER (TITLE + PRICE + CTA) */}
      <section className={styles.pkgHeader}>
       <div>
  <h1 className={styles.pkgTitle}>Meghalaya Honeymoon & Romantic Escape</h1>
  <p className={styles.pkgSubtitle}>
    Experience the magic of the 'Scotland of the East' with Atlas Travel House.Indulge in misty hills, private waterfalls, and memories crafted just for you.
  </p>
</div>

        <div className={styles.pkgPricing}>
          <h2>₹35,000 / person</h2>
          {/* <button className={styles.callBtn}>Call Now</button> */}
          <a
  href="tel:+919971881444"
  className={styles.callBtn}
  style={{ textDecoration: "none" }}
>
  Call Now
</a>
        </div>
      </section>

      
         <nav className={styles.toc}>
  <a href="#overview">Overview</a>
  <a href="#itinerary">Itinerary</a>
  <a href="#hotels">Hotels</a>
  <a href="#inclusions">Inclusions</a>
  <a href="#alsocheckout">Also Check</a>
</nav>

      {/* OVERVIEW */}
<section id="overview" className={styles.pkgSection}>
  <h2>Package Highlights & Inclusions</h2>
  <ul className={styles.pkgList}>
    <li><b>Duration:</b> 6 Days of Romantic Exploration (5 Nights)</li>
    <li><b>Circuit:</b> Shillong, Cherrapunji, Dawki & Mawlynnong</li>
    <li><b>Private Travel:</b> Dedicated Chauffeur-Driven Sedan/SUV</li>
    <li><b>Inclusions:</b> Daily Breakfast & Special Romantic Stays</li>
    <li><b>Guided:</b> 24/7 Priority Support by Atlas Travel House</li>
  </ul>
</section>

      {/* ITINERARY */}
<section id="itinerary" className={styles.pkgSection}>
        <h2>Day-wise Itinerary</h2>

        <div className={styles.pkgItinerary}>
          <div className={styles.pkgDay}>
            <h4>Day 1</h4>
            <p>Arrival in Guwahati followed by a scenic transfer to Shillong, with a stop at the picturesque Umiam Lake enroute.
Upon arrival, enjoy local sightseeing (time permitting) before an overnight stay in Shillong.</p>
          </div>

          <div className={styles.pkgDay}>
            <h4>Day 2</h4>
            <p>Excursion from Shillong to explore the stunning Krang Suri Falls and Phe Phe Falls, known for their crystal-clear waters and scenic beauty.
Return to Shillong by evening for an overnight stay.</p>
          </div>

          <div className={styles.pkgDay}>
            <h4>Day 3</h4>
            <p>Journey from Shillong to Cherrapunjee via Mawlynnong, Asia’s cleanest village, with visits to the Living Root Bridge at Riwai and the crystal-clear Dawki River (boating optional).
Continue to Cherrapunjee for an overnight stay.
</p>
          </div>

          <div className={styles.pkgDay}>
            <h4>Day 4</h4>
            <p>Explore Cherrapunjee’s highlights including Nohkalikai Falls, Seven Sisters Falls, Mawsmai Cave, and Arwah Cave with scenic viewpoints.
Later, return to Shillong for an overnight stay.
</p>
          </div>

          <div className={styles.pkgDay}>
            <h4>Day 5</h4>
            <p>Visit the breathtaking Laitlum Canyon before transferring from Shillong to Guwahati.
Enjoy an optional Brahmaputra River cruise in the evening followed by an overnight stay.
</p>
          </div>

          <div className={styles.pkgDay}>
            <h4>Day 6</h4>
            <p>Visit the sacred Kamakhya Temple in Guwahati before your scheduled airport transfer for departure.
</p>
          </div>
        </div>
      </section>

      {/* HOTEL INFO */}
<section id="hotels" className={styles.pkgSection}>
  <h2>Hotel Information</h2>

  <div className={styles.hotelBlock}>
    <h3>3★ Standard Hotels (Budget Friendly)</h3>
    <ul className={styles.pkgList}>
      <li><strong>Shillong:</strong> Hotel Alpine Continental / Similar</li>
      <li><strong>Cherrapunjee:</strong> Sa-I-Mika Resort / Similar</li>
      <li><strong>Guwahati:</strong> Hotel Dynasty / Similar</li>
    </ul>
  </div>

  <div className={styles.hotelBlock}>
    <h3>4★ Premium Hotels (Recommended)</h3>
    <ul className={styles.pkgList}>
      <li><strong>Shillong:</strong> IORA Resort / Windermere / Polo Towers</li>
      <li><strong>Cherrapunjee:</strong> Jiva Resort / Similar</li>
      <li><strong>Guwahati:</strong> Hotel Radisson Blu / Royale De Casa</li>
    </ul>
  </div>

</section>

      {/* INCLUSIONS & EXCLUSIONS */}
<section id="inclusions" className={styles.pkgFlex}> 
  <div>
    <h2>What’s Included</h2>
    <ul className={styles.pkgList}>
      <li><b>Stay:</b> 5 nights comfortable hotel accommodation.</li>
      <li><b>Meals:</b> Daily breakfast at all hotels.</li>
      <li><b>Transport:</b> Private vehicle for all transfers & sightseeing.</li>
      
      <li><b>Entrance/Tickets:</b> Tickets for sightseeing & activities.</li>

      <li><b>Pickup & Drop:</b> Airport pickup and drop included.</li>
      <li><b>Charges:</b> Toll, parking, and driver allowance covered.</li>
    </ul>
  </div>

  <div>
    <h2>Exclusions</h2>
    <ul className={styles.pkgList}>
      <li><b>Flights:</b> Airfare not included.</li>
      <li><b>Meals:</b> Lunch and dinner excluded.</li>
      <li><b>Activities:</b> Boating and other optional charges.</li>
      <li><b>Personal:</b> Any personal expenses.</li>
    </ul>
  </div>
</section>



<section id="alsocheckout" className={styles.pkgSection}>
  <div className={styles.checkoutHeader}>
    <h2 className={styles.checkoutTitle}>Also Checkout</h2>

 <Link to="/meghalayatourpackage" className={styles.viewAll}>
  View All Meghalaya Packages →
</Link>
  </div>

  <div className={styles.checkoutGrid}>

  <PackageCard
    image={family}
    title="Meghalaya Family Holiday Package"
    highlights={[
      "<b>Shillong:</b> Full city tour & local market experience in Shillong",
      "<b>Cherrapunji:</b> Grand waterfalls & easy scenic sightseeing in Cherrapunjee",
      "<b>Dawki:</b> Safe & enjoyable river boating at Dawki",
      "Family-friendly hotels (3 Star) & comfortable travel",
      "Relaxed itinerary suitable for all age groups",
    ]}
    destinations="Shillong – Cherrapunjee – Dawki – Mawlynnong"
    duration="5 Nights / 6 Days"
    price="₹25,000 / person (on twin sharing)"
    detailsLink="/meghalayatourpackage/family"
  />


  </div>
</section>
    </main>
  );
}